var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c("SaasIcon", {
          staticClass: "mr-1 secondary-blue",
          attrs: {
            icon: "svgLogoSellsyText",
            width: 118,
            height: 28,
            viewBox: "0 0 118 28"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "flex-row hp-9" }, [
      _c(
        "div",
        { staticClass: "acenter m-auto ai-center" },
        [
          _vm.isDisplayed
            ? _c("div", [
                _c("img", {
                  attrs: {
                    src: "/ressources/logged/img/errors/lock-closed.svg",
                    width: 210,
                    height: 160
                  }
                }),
                _vm._v(" "),
                _c("h1", { staticClass: "fs-32 lh-39 font-weight mt-8" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.title) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "gray-60 fs-5 lh-26 mt-3 block mb-6" },
                  _vm._l(_vm.subtitles, function(subtitle, index) {
                    return _c("span", { key: index, staticClass: "block" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(subtitle) +
                          "\n                    "
                      )
                    ])
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }